import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import { useDispatch, useSelector } from "react-redux";
import successPayment from "../assets/lottie/SuccessPayment.json";
import axios from "axios";
import { getToken } from "../slice/tokenSlice";
import { cibilTable } from "../assets/data/cibilTable";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import GaugeChart from "react-gauge-chart";

const UserCibil = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);

  const [show, setShow] = useState(false);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [summary, setSummary] = useState({
    Sanction_Amt_Highest_Credit: 0,
    Current_Balance: 0,
    EMI_Amount: 0,
  });
  const [filterInputs, setFilterInputs] = useState({
    status: "",
    entries: "All",
  });

  const successPaymentOption = {
    loop: true,
    autoplay: true,
    animationData: successPayment,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const getCibil = async () => {
    try {
      const token = await dispatch(getToken());
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/CIBIL_Report`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        }
      );

      if (res.status === 200) {
        const data = res.data.data;
        setData1(data);
        setData2(data);

        let Sanction_Amt_Highest_Credit = 0;
        let Current_Balance = 0;
        let EMI_Amount = 0;

        data.forEach((item) => {
          Sanction_Amt_Highest_Credit += item.Sanction_Amt_Highest_Credit;
          Current_Balance += item.Current_Balance;
          EMI_Amount += item.EMI_Amount;
        });

        setSummary({
          Sanction_Amt_Highest_Credit,
          Current_Balance,
          EMI_Amount,
        });
      } else {
        alert("Failed to fetch CIBIL data");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filterData = () => {
    const statusFilter = filterInputs.status.toLowerCase();
    const filtered = data1.filter((item) => {
      return (
        !statusFilter ||
        (statusFilter === "active" && item.Current_Balance > 0) ||
        (statusFilter === "closed" && item.Current_Balance <= 0)
      );
    });
    let tempSA = 0;
    let tempCB = 0;
    let tempEMI = 0;
    filtered.forEach((item) => {
      tempSA += item.Sanction_Amt_Highest_Credit;
      tempCB += item.Current_Balance;
      tempEMI += item.EMI_Amount;
    });
    setSummary({
      ...summary,
      Sanction_Amt_Highest_Credit: tempSA,
      Current_Balance: tempCB,
      EMI_Amount: tempEMI,
    });
    setData2(filtered);
  };

  useEffect(() => {
    filterData();
  }, [filterInputs]);

  const resetFilter = () => {
    setFilterInputs({ status: "", entries: "All" });
    setData2(data1);
  };

  const formatCurrency = (amount) =>
    amount && !isNaN(amount)
      ? `Rs ${Number(amount).toLocaleString("en-IN")}`
      : "0";
  //
  const [percentage, setPercentage] = useState(0);
  const [status, setStatus] = useState("");
  const [cibilColor, setCibilColor] = useState("#999");
  useEffect(() => {
    if (user && user.Credit_Score) {
      getCibil();
      const score = user.Credit_Score;

      getCibilPercentage(user.Credit_Score);

      if (score >= 300 && score <= 549) {
        setCibilColor("#FF4D4F");
        setStatus("Poor");
      } else if (score >= 550 && score <= 649) {
        setCibilColor("#FFA940");
        setStatus("Fair");
      } else if (score >= 650 && score <= 749) {
        setCibilColor("#73D13D");
        setStatus("Good");
      } else if (score >= 750 && score <= 799) {
        setCibilColor("#52C41A");
        setStatus("Very Good");
      } else if (score >= 800 && score <= 900) {
        setCibilColor("#237804");
        setStatus("Excellent");
      } else {
        setCibilColor("#999");
        setStatus("");
      }
    }
  }, [user]);

  function getCibilPercentage(score) {
    const minScore = 300;
    const maxScore = 900;
    if (score < minScore || score > maxScore) {
      return "Invalid CIBIL score";
    }
    const percentage = (score - minScore) / (maxScore - minScore);
    setPercentage(Number(percentage.toFixed(2)));
  }

  return (
    <div>
      {user && (
        <>
          {data1.length === 0 ? (
            user.Account_Status.toLowerCase() === "enrolled" && (
              <div className="successful-payment-grid py-4 px-2 text-center bg-gradient">
                <h2 className="mb-2">Your payment is successful.</h2>
                <h2 className="mb-2">Amount: Rs 599</h2>
                <div className="lottie-box">
                  <Lottie options={successPaymentOption} />
                </div>
                <h2>Thank You for Choosing Settle My Loan!</h2>
                <p>
                  Your enrollment has been successfully confirmed! We're excited
                  to help you take the first step toward financial freedom.
                </p>
                <button
                  className="secondary-button mt-4"
                  onClick={() => setShow(true)}
                >
                  Check free credit score
                </button>
              </div>
            )
          ) : (
            <div>
              <div className="text-center mb-4">
                <h2 className="mb-2">
                  Welcome back <span className="fw-bold">{user.Full_Name}</span>
                </h2>
                <div className="mt-2">
                  <p className="pb-2">
                    Your CIBIL Score is{" "}
                    <span className="fw-bold" style={{ color: cibilColor }}>
                      {status}
                    </span>
                  </p>
                  <div className="cibil-bar">
                    <GaugeChart
                      id="gauge-chart1"
                      colors={[
                        "#FF4D4F",
                        "#FFA940",
                        "#73D13D",
                        "#52C41A",
                        "#237804",
                      ]}
                      nrOfLevels={5}
                      percent={percentage}
                      arcWidth={0.2}
                      cornerRadius={2}
                      arcPadding={0.025}
                      needleColor="#000"
                      hideText={true}
                      animate={true}
                      style={{ width: "200px" }}
                      formatTextValue={() => `${user.Credit_Score}`}
                    />
                    <small className="level1">300</small>
                    <small className="level2">579</small>
                    <small className="level3">669</small>
                    <small className="level4">739</small>
                    <small className="level5">900</small>
                  </div>
                  <div
                    className="rounded border py-1 px-3 d-inline-block"
                    style={{ background: cibilColor }}
                  >
                    <h2 className="fw-bold text-white">{user.Credit_Score}</h2>
                  </div>
                </div>
              </div>

              <div className="cibil-summary-grid">
                <div>
                  <p className="fw-bold">Total Sanction amount</p>
                  <p>{formatCurrency(summary.Sanction_Amt_Highest_Credit)}</p>
                </div>
                <div>
                  <p className="fw-bold">Current balance</p>
                  <p>{formatCurrency(summary.Current_Balance)}</p>
                </div>
                <div>
                  <p className="fw-bold">EMI amount</p>
                  <p>{formatCurrency(summary.EMI_Amount)}</p>
                </div>
                <div>
                  <p className="fw-bold text-capitalize">
                    {filterInputs.status === "" ? "Total" : filterInputs.status}{" "}
                    accounts
                  </p>
                  <p>{data2.length}</p>
                </div>
              </div>

              <div className="filter">
                <div>
                  <label>Filter by Account Status</label>
                  <select
                    className="input"
                    name="status"
                    value={filterInputs.status}
                    onChange={handleFilterInputs}
                  >
                    <option value="">Please select</option>
                    <option value="active">Active</option>
                    <option value="closed">Closed</option>
                  </select>
                </div>
                <div>
                  <label>Show Entries</label>
                  <select
                    className="input"
                    name="entries"
                    value={filterInputs.entries}
                    onChange={handleFilterInputs}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="All">All</option>
                  </select>
                </div>
                <button
                  className="button w-100 text-center"
                  onClick={resetFilter}
                >
                  Reset Filter
                </button>
              </div>

              <div className="table-responsive mt-4">
                <table className="table table-bordered table-hover table-striped cibil-table">
                  <thead>
                    <tr>
                      {cibilTable.map((item, index) => (
                        <th key={index}>{item}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data2
                      .slice(
                        0,
                        filterInputs.entries === "All"
                          ? data1.length
                          : parseInt(filterInputs.entries)
                      )
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.Lender_Name || ""}</td>
                          <td>{item.Account_Number || ""}</td>
                          <td>
                            {item.Actual_Payment.toString() === "-1"
                              ? 0
                              : formatCurrency(item.Actual_Payment)}
                          </td>
                          <td>
                            {formatCurrency(item.Sanction_Amt_Highest_Credit)}
                          </td>
                          <td>
                            {item.Open_Date &&
                              item.Open_Date.split("-").reverse().join("-")}
                          </td>
                          <td>{formatCurrency(item.Current_Balance)}</td>
                          <td>
                            {item.Amount_Overdue.toString() === "-1"
                              ? 0
                              : formatCurrency(item.Amount_Overdue)}
                          </td>
                          <td>{item.Account_Type || ""}</td>
                          <td>
                            {item.EMI_Amount.toString() === "-1"
                              ? 0
                              : formatCurrency(item.EMI_Amount)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserCibil;
